import classNames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// import { analytics } from 'common/utils';
import { fileLink } from 'utils/file-link';
import * as css from './ItemPicture.scss';

class ItemPicture extends PureComponent {
	static propTypes = {
		className: PropTypes.string,
		isAllowSelect: PropTypes.bool.isRequired,
		isSelected: PropTypes.bool.isRequired,
		onItemClick: PropTypes.func.isRequired,
		onShowModal: PropTypes.func.isRequired,
		title: PropTypes.string.isRequired,
		subtitle: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
		// categoryId: PropTypes.string.isRequired,
		file: PropTypes.shape({
			selected: PropTypes.string,
			file: PropTypes.shape({
				url: PropTypes.string,
			}),
		}).isRequired,
		order: PropTypes.number.isRequired,
	};

	static defaultProps = {
		className: '',
	};

	onItemClick = () => {
		if (!this.props.isSelected && !this.props.isAllowSelect) {
			this.props.onShowModal();
			return;
		}

		this.props.onItemClick(this.props.id);
	};

	render() {
		const { className, isSelected, title, subtitle, file, order } = this.props;

		return (
			<div
				onClick={this.onItemClick}
				className={classNames(
					css.item,
					{ [css.selected]: isSelected, [css.album]: order === 2 || order === 3 || order === 4 },
					className
				)}
			>
				<div className={css.bg} style={{ backgroundImage: `url(${fileLink(file)})` }} />
				<div className={css.namesWrapper}>
					<div className={css.itemTitle}>{title}</div>
					{subtitle && <div className={css.itemSubtitle}>{subtitle}</div>}
				</div>
			</div>
		);
	}
}

export default ItemPicture;
